import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { addToRecent } from "utils/builder/IModelsTree";
import { useDashboardState } from "components/DashboardContext";
import "./VersionsModal.scss";
import ModalComponent from "../../modals/ModalComponent";

import VersionsItem from "components/uiComponents/VersionsItem";
import UniversalButton from "components/uiComponents/UniversalButton";
import ChooseCategory from "../ChooseCategory";

const VersionsModal = ({
  versions,
  parentItem,
  title,
  closeModal,
  fileIconPath,
}) => {
  const history = useHistory();
  const [activeVersion, setActiveVersion] = useState(null);
  const [chooseCategoryModal, setChooseCategoryModal] = useState(false);
  const [versionsModalStyles, setVersionsModalStyles] = useState({});

  const {
    setActiveProject,
  } = useDashboardState();

  const handleLoad = (e) => {
    e.preventDefault();
    setVersionsModalStyles({display: "none"})
    setChooseCategoryModal(true);
  };

  const loadModel = () => {
    addToRecent(parentItem);
    setActiveProject(activeVersion);

    history.push({
      pathname: `/project/${activeVersion.idToOpen}`,
      state: { project: activeVersion }
    });
  };

  const handleCancel = () => {
    closeModal();
  };

  const closeCategoryModal = () => {
    closeModal();
    setChooseCategoryModal(false);
  };

  return (
    <>
      <div className="versions-modal" style={versionsModalStyles}>
        <h2>Version history</h2>

        <h3>{title}</h3>

        <div className="versions-modal__versions_container">
          {versions && Array.isArray(versions) &&
            versions?.map(item => {
              const handleItemClick = () => {
                setActiveVersion(item);
              };

              return (
                <VersionsItem
                  {...item}
                  key={item.id}
                  onClick={handleItemClick}
                  isActive={item.id === activeVersion?.id}
                  fileIconPath={fileIconPath}
                />
              );
            })
          }
        </div>

        <div className="versions-modal__btns">
          <div className="versions-modal__btns_btn">
            <UniversalButton
              type="button"
              label="Close"
              size="lg"
              labelColor="blue"
              labelHoverColor="blue"
              backgroundColor="white"
              backgroundHoverColor="blue-light"
              onClick={handleCancel}
            />
          </div>

          <UniversalButton
            type="button"
            label="Load"
            size="lg"
            labelColor="white"
            labelHoverColor="white"
            backgroundColor="orange"
            backgroundHoverColor="orange-light"
            isDisabled={!activeVersion}
            onClick={handleLoad}
          />
        </div>
      </div>
      <ModalComponent
        onCloseModal={closeCategoryModal}
        isVisible={chooseCategoryModal}
      >
        <ChooseCategory loadModel={loadModel}/>
      </ModalComponent>
    </>
  );
};

export default VersionsModal;
